export enum InvoiceStatusEnum {
  New = 1,
  Draft = 2,
  Pending = 3,
  Paid = 4,
  Cancelled = 5,
  Authorized = 6,
  ProForma = 7
}

export enum InvoiceStatusNameValueEnum {
  New = 'New',
  Draft = 'Draft',
  Pending = 'Pending',
  Overdue = 'Orderdue',
  Paid = 'Paid',
  Cancelled = 'Cancelled',
  Authorized = 'Authorized',
  ProForma = 'ProForma'
}